import { render } from "./DashboardKpiCard.vue?vue&type=template&id=401ae9d0&scoped=true"
import script from "./DashboardKpiCard.vue?vue&type=script&lang=js"
export * from "./DashboardKpiCard.vue?vue&type=script&lang=js"

import "./DashboardKpiCard.vue?vue&type=style&index=0&id=401ae9d0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-401ae9d0"]])

export default __exports__